export default {
  FETCH_LICENCIAS: 'FETCH_LICENCIAS',
  FETCH_LICENCIAS_SUCCESS: 'FETCH_LICENCIAS_SUCCESS',
  ABRIR_MODAL_LICENCIAS: 'ABRIR_MODAL_LICENCIAS',
  ABRIR_MODAL_LICENCIAS_SUCCESS: 'ABRIR_MODAL_LICENCIAS_SUCCESS',
  SUBMIT_LICENCIA: 'SUBMIT_LICENCIA',
  CERRAR_MODAL_LICENCIAS: 'CERRAR_MODAL_LICENCIAS',
  CERRAR_MODAL_LICENCIAS_SUCCESS: 'CERRAR_MODAL_LICENCIAS_SUCCESS',
  ON_DELETE_LICENCIA: 'ON_DELETE_LICENCIA'
}